import {
  CheckoutDataFragment,
  CheckoutSamplesInput,
} from "../../../../api/backend/backend-api"
import { checkoutSetSamples } from "../../../../api/backend/checkout/api"
import { basketChange } from "./basketChange"

export const setSamples = (
  samples: CheckoutSamplesInput,
  callback?: () => void,
  errorCallback?: (error: any) => void
) => {
  return basketChange({
    operation: async (basket, languageId) => {
      const result = await checkoutSetSamples({
        id: basket.shopify.id,
        languageId,
        samples,
      })
      return result.data?.checkoutSetSamples.data as CheckoutDataFragment
    },
    callback,
    errorCallback,
  })
}
